import React from "react";

function Modal({ children }) {
  return (
    <div
      className="relative z-[20]"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-white" aria-hidden="true"></div>
      <div className="fixed inset-0 z-10 w-full bg-gray-1 overflow-y-auto">
        <div className="w-full max-w-[736px] bg-white mx-auto">
          <div className="relative w-full min-h-screen overflow-hidden">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
